/**
 * Olfactive Family Row [New]
 * Scroll reveal + AJAX ATC (same as Bestsellers: theme.ProductForm / ajaxProduct:added → cart drawer)
 */
(function () {
  var SECTION_TYPE = 'olfactive-family-row';

  function revealCards(root) {
    var cards = root.querySelectorAll('.vg-ofr__grid .vg-bestsellers__slide, .vg-ofr__grid .vg-pc');
    cards.forEach(function (card, i) {
      card.style.transitionDelay = Math.min(i * 80, 320) + 'ms';
      card.classList.add('is-inview');
    });
  }

  function revealIntensityBars(root) {
    root.querySelectorAll('.vg-intensity-bar').forEach(function (bar, i) {
      bar.style.setProperty('--vg-ib-delay', 250 + Math.min(i * 90, 270) + 'ms');
      bar.classList.add('is-inview');
    });
  }

  function initAtcForms(root) {
    var forms = root.querySelectorAll('.vg-pc__atc-form');
    forms.forEach(function (form) {
      if (form.dataset.vgPcBound) return;
      form.dataset.vgPcBound = '1';

      if (window.theme && theme.ProductForm) {
        try {
          new theme.ProductForm(form, '.add-to-cart', {});
          return;
        } catch (e) {
          /* fall through to manual handler */
        }
      }

      form.addEventListener('submit', function (evt) {
        evt.preventDefault();
        var btn = form.querySelector('[data-add-to-cart]');
        if (btn) btn.classList.add('btn--loading');

        var data = new FormData(form);
        var addUrl =
          (theme.routes && theme.routes.cartAdd) ||
          (window.routes && window.routes.cart_add_url) ||
          '/cart/add.js';

        fetch(addUrl, {
          method: 'POST',
          body: data,
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin',
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (payload) {
            if (btn) btn.classList.remove('btn--loading');
            if (payload && payload.status === 422) return;

            if (theme.settings && theme.settings.cartType === 'page') {
              window.location = (theme.routes && theme.routes.cartPage) || '/cart';
              return;
            }

            document.dispatchEvent(
              new CustomEvent('ajaxProduct:added', {
                detail: { product: payload, addToCartBtn: btn },
                bubbles: true,
              })
            );
          })
          .catch(function () {
            if (btn) btn.classList.remove('btn--loading');
          });
      });
    });
  }

  function enhance(root) {
    if (!root || root._vgOfrReady) return;
    root._vgOfrReady = true;

    initAtcForms(root);

    var nodes = root.querySelectorAll('[data-ofr-reveal]');
    var grid = root.querySelector('.vg-ofr__grid');

    function showAll() {
      nodes.forEach(function (n) {
        n.classList.add('is-in');
      });
      revealCards(root);
      revealIntensityBars(root);
    }

    if (typeof IntersectionObserver === 'undefined') {
      showAll();
      return;
    }

    if (nodes.length) {
      var copyIo = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              copyIo.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: '-70px 0px' }
      );
      nodes.forEach(function (n) {
        copyIo.observe(n);
      });
    }

    if (grid) {
      var cardIo = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            revealCards(root);
            revealIntensityBars(root);
            cardIo.disconnect();
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
      );
      cardIo.observe(grid);
    } else {
      revealIntensityBars(root);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="' + SECTION_TYPE + '"]').forEach(enhance);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    var root =
      (event.target.querySelector &&
        event.target.querySelector('[data-section-type="' + SECTION_TYPE + '"]')) ||
      null;
    if (!root && event.target.getAttribute && event.target.getAttribute('data-section-type') === SECTION_TYPE) {
      root = event.target;
    }
    if (root) {
      root._vgOfrReady = false;
      root.querySelectorAll('.vg-pc__atc-form').forEach(function (form) {
        delete form.dataset.vgPcBound;
      });
      enhance(root);
    }
  });
})();
